import React, { Component } from "react";
import { connect } from "react-redux";
import ChangePassword from "../Components/ChangePassword";
import { close_snack_bar } from "../../../../store/actions/snackbarActions";
import { onLogout, passwordChange } from "../../../auth/authActions";

export class ChangePasswordContainer extends Component {
    render() {
        return <ChangePassword {...this.props} />;
    }
}
export const mapStateToProps = (store) => {
    return {
        login: store.login,
        loader: store.loader,
        snackbar: store.snackbar,
        client: store.client,
    };
};
export const mapDispatchToProps = (dispatch) => {
    return {
        close_snack_bar: () => {
            dispatch(close_snack_bar());
        },
        passwordChange: (token, user_id, oldpassword, newpassword) => {
            dispatch(passwordChange(token, user_id, oldpassword, newpassword));
        },
        onLogout: (token) => {
            dispatch(onLogout(token));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordContainer);
